(() => {
  const setupCookieBanner = () => {
    const banner = document.querySelector('#shopify-pc__banner');

    if (!banner || banner.dataset.ckbReadMoreReady === 'true') {
      return;
    }

    const body = banner.querySelector('.shopify-pc__banner__body');
    const paragraph = body?.querySelector('p');

    if (!body || !paragraph) {
      return;
    }

    const toggle = document.createElement('button');

    toggle.type = 'button';
    toggle.className = 'ckb-cookie-read-more';
    toggle.textContent = 'Read more';
    toggle.setAttribute('aria-expanded', 'false');

    paragraph.insertAdjacentElement('afterend', toggle);

    toggle.addEventListener('click', () => {
      const expanded = banner.classList.toggle('ckb-cookie-expanded');

      toggle.textContent = expanded ? 'Read less' : 'Read more';
      toggle.setAttribute(
        'aria-expanded',
        expanded ? 'true' : 'false'
      );
    });

    banner.dataset.ckbReadMoreReady = 'true';
  };

  setupCookieBanner();

  const observer = new MutationObserver(() => {
    setupCookieBanner();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();